import { PAGE_KEY } from './constants';

export const es = {
  [PAGE_KEY]: {
    PAGE_TITLE: 'Comunidad',
    PAGE_DESCRIPTION:
      'Fomenta la comunicación y el sentido de comunidad en tu compañía con un canal donde podrás publicar contenidos de interés.',
    GLOBAL_ERROR_MESSAGE:
      'No se puedo ejecutar la acción. Por favor, inténtalo nuevamente.',
    GLOBAL_CANCEL: 'Cancelar',

    CHANNEL_INFO_ERROR_TITLE: 'Ocurrió un error',
    CHANNEL_INFO_ERROR_DESCRIPTION:
      'Ocurrió un error al cargar la información del canal.',

    PAGE_BREADCRUMB_COMMUNITY: 'Comunidad',
    PAGE_BREADCRUMB_HOME: 'Inicio',
    PAGE_BREADCRUMB_CONNECTION: 'Conexión',
    PAGE_BREADCRUMB_CHANNELS: 'Mis canales',

    BANNER_PUBLIC_LABEL: 'Público',
    BANNER_PUBLIC_TOOLTIP: 'Toda la compañía puede ver las publicaciones.',
    BANNER_PRIVATE_LABEL: 'Privado',
    BANNER_PRIVATE_TOOLTIP:
      'Solo los administradores pueden ver las publicaciones.',

    TABS_FEED_LABEL: 'Muro',
    TABS_INFORMATION_LABEL: 'Información',
    TABS_SCHEDULED_LABEL: 'Programadas',
    CONFIGURATION_BUTTON_LABEL: 'Configuración',
    ADMIN_EDIT_PERMISSION_REQUIRED_TOOLTIP:
      'No tienes permisos para realizar esta acción.',

    CHANNEL_INFORMATION_TITLE: 'Información del canal',
    CHANNEL_INFORMATION_NAME: 'Nombre del canal',
    CHANNEL_INFORMATION_DESCRIPTION: 'Descripción',
    CHANNEL_INFORMATION_PERMISSIONS: 'Permisos',
    CHANNEL_INFORMATION_PUBLIC: 'Canal público.',
    CHANNEL_INFORMATION_PRIVATE: 'Canal privado.',
    CHANNEL_INFORMATION_ADMIN_PUBLISH:
      'Solo los administradores pueden publicar.',
    CHANNEL_INFORMATION_DESCRIPTION_CONTENT:
      'Bienvenido al espacio donde compartiremos anuncios con toda la compañía.',

    // Post interactions
    POST_VIEW_COMMENTS: 'Ver {{count}} comentario',
    POST_VIEW_COMMENTS_plural: 'Ver los {{count}} comentarios',
    POST_VIEW_HIDE_COMMENTS: 'Ocultar comentarios',
    POST_REACT_BUTTON: 'Reaccionar',
    POST_COMMENT_BUTTON: 'Comentar',
    POST_VIEW_CREATED_AT: 'Creado: {{date}}',
    POST_VIEW_SHOW_MORE: 'Ver más',
    POST_VIEW_SHOW_LESS: 'Ver menos',
    POST_VIEW_UPDATED_AT: 'Editado: {{date}}',
    POST_VIEW_MENTION_INACTIVE_USER: 'Usuario inactivo',

    // Error view
    ERROR_TITLE: 'Ocurrió un error',
    ERROR_DESCRIPTION:
      'Haz clic en el botón para reintentar cargar nuevamente.',
    ERROR_RETRY_BUTTON: 'Reintentar',

    // Empty view
    EMPTY_TITLE: 'Aún no hay publicaciones en este muro',
    EMPTY_DESCRIPTION:
      'Realiza la primera publicación para generar interacciones entre tus colaboradores.',
    EMPTY_DESCRIPTION_END_USER:
      'Pronto conocerás las novedades de tu compañía.',
    EMPTY_CREATE_BUTTON: 'Crear publicación',
    EMPTY_NO_POSTS_ALT: 'No posts',

    COMMENT_INPUT_PLACEHOLDER:
      'Escribe un comentario y/o utiliza @ para mencionar a alguien',
    COMMENT_INPUT_BUTTON: 'Comentar',

    // @mention autosuggest (shared by post + comment editors)
    MENTION_EMPTY_LABEL: 'No se encontraron personas con ese nombre.',
    MENTION_LOADING_LABEL: 'Buscando personas…',
    MENTION_ERROR_LABEL:
      'No se pudo cargar la lista de menciones. Intenta recargar.',

    // Warning dialog shown before publishing/commenting in a private channel
    // when a tagged user is neither a member nor part of the channel's
    // segmentation (RN-002 / VAL-002).
    MENTION_WARNING_TITLE:
      'Algunos colaboradores etiquetados no son miembros de este canal o no cumplen con la segmentación requerida para pertenecer a él.',
    MENTION_WARNING_DESCRIPTION:
      'Por esta razón, no podrán ver la publicación ni recibir notificaciones de las menciones.',

    // User detail drawer opened when a mention chip is clicked
    MENTION_DRAWER_TITLE: 'Detalle de usuario',
    MENTION_DRAWER_MEMBER_BADGE: 'Miembro del canal',
    MENTION_DRAWER_OUTSIDE_BADGE: 'Fuera del canal',
    MENTION_DRAWER_MEMBER_NOTE:
      '{{name}} es miembro de este canal. Si lo mencionas, recibirá el correo de menciones al día siguiente.',
    MENTION_DRAWER_OUTSIDE_NOTE:
      '{{name}} no es miembro de este canal. La mención será visible pero no recibirá el correo de menciones.',
    MENTION_DRAWER_CLOSE: 'Cerrar',
    MENTION_DRAWER_TAB_INFO: 'Información',
    MENTION_DRAWER_TAB_LEARNING: 'Aprendizaje',
    MENTION_DRAWER_ABOUT_ME: 'Acerca de mí',
    MENTION_DRAWER_SITE: 'Sede',
    MENTION_DRAWER_CITY: 'Ciudad',
    MENTION_DRAWER_COUNTRY: 'País',
    MENTION_DRAWER_GENDER: 'Género',
    MENTION_DRAWER_BIRTHDAY: 'Cumpleaños',
    MENTION_DRAWER_PHONE: 'Teléfono',
    MENTION_DRAWER_GENDER_MALE: 'Masculino',
    MENTION_DRAWER_GENDER_FEMALE: 'Femenino',
    MENTION_DRAWER_GENDER_OTHER: 'Otro',
    MENTION_DRAWER_STATUS_ACTIVE: 'Activo',
    MENTION_DRAWER_STATUS_PENDING: 'Pendiente',
    MENTION_DRAWER_STATUS_INACTIVE: 'Inactivo',
    MENTION_DRAWER_STATUS_DELETED: 'Eliminado',
    MENTION_DRAWER_USER_TYPE_USER: 'Usuario',
    MENTION_DRAWER_USER_TYPE_ADMIN: 'Administrador',
    MENTION_DRAWER_USER_TYPE_SUBADMIN: 'Subadmin',
    MENTION_DRAWER_USER_TYPE_LEADER: 'Líder',
    MENTION_DRAWER_BACK: 'Volver',
    MENTION_DRAWER_VIEW_PROFILE: 'Ver perfil',
    MENTION_DRAWER_RETRY: 'Reintentar',
    MENTION_DRAWER_LEARNING_EMPTY:
      'No hay información de aprendizaje disponible.',
    MENTION_DRAWER_ERROR: 'No se pudo cargar el detalle del usuario.',

    // Aprendizaje tab (Cursos / Rutas) — organigrama parity
    TABS_LEARNING_COURSES: 'Cursos',
    TABS_LEARNING_TRACKS: 'Rutas',
    TABS_LEARNING_PROGRESS_TRACK_TAG: 'Ruta de aprendizaje',
    TABS_LEARNING_COURSE_TOOLTIP_OWN: 'Curso propio',
    TABS_LEARNING_COURSE_TOOLTIP_CREHANA: 'Curso Crehana',
    TABS_LEARNING_PROGRESS_INFO_1: '{{amount}}% de progreso',
    TABS_LEARNING_PROGRESS_INFO_2: '{{amount}} cursos requeridos',
    TABS_LEARNING_PROGRESS_TOTAL: 'AVANCE TOTAL',
    TABS_LEARNING_PROGRESS_TOTAL_TOOLTIP:
      'Indica el porcentaje de avance con\nrespecto al total de cursos asignados',
    TABS_LEARNING_PROGRESS_TOTAL_TOOLTIP_TRACK:
      'Indica el porcentaje de avance con\nrespecto al total de rutas asignadas',
    TABS_LEARNING_COURSES_EMPTY: 'El usuario no tiene cursos asignados.',
    TABS_LEARNING_TRACKS_EMPTY: 'El usuario no tiene rutas asignadas.',
    TABS_LEARNING_ERROR: 'No se pudo cargar la actividad de aprendizaje.',
    TABS_LEARNING_PAGINATION_PREV: 'Anterior',
    TABS_LEARNING_PAGINATION_NEXT: 'Siguiente',
    MENTION_DRAWER_EMPTY_VALUE: '-',
    COMMENT_SUCCESS_MESSAGE: 'Comentario publicado con éxito.',
    COMMENT_INPUT_REQUIRED_ERROR: 'El comentario es requerido',
    COMMENT_INPUT_MAX_LENGTH_ERROR:
      'El comentario debe tener menos de 500 caracteres',
    COMMENT_OFFENSIVE_WORDS_ERROR_MESSAGE:
      'El comentario contiene palabras no permitidas: {{words}}.',
    POST_OFFENSIVE_WORDS_ERROR_MESSAGE:
      'El contenido tiene palabras que no están permitidas usar: {{words}}.',

    COMMENT_UPLOAD_IMAGE_BUTTON_LABEL: 'Subir imagen',
    COMMENT_UPLOAD_IMAGE_FORMAT_LABEL: 'Peso y formatos',
    COMMENT_UPLOAD_IMAGE_TOOLTIP:
      'Formato: JPG, PNG o GIF.\nTamaño máximo: 5 MB.',
    COMMENT_IMAGE_ALT_FALLBACK: 'Imagen adjuntada por {{author}}',
    COMMENT_IMAGE_CLOSE_PREVIEW: 'Cerrar vista previa de la imagen',

    COMMENT_LIKE_BUTTON: 'Me gusta',
    SHOW_MORE_COMMENTS: 'Ver más comentarios',

    POST_EDIT_COMMENT_BUTTON: 'Editar',
    COMMENT_EDIT_SAVE_BUTTON: 'Guardar cambios',
    COMMENT_EDIT_CANCEL_BUTTON: 'Cancelar',
    POST_DELETE_COMMENT_BUTTON: 'Eliminar',

    POST_REACTION_LIKE: 'Me gusta',
    POST_REACTION_LOVE: 'Me encanta',
    POST_REACTION_INTERESTED: 'Me interesa',

    DELETE_COMMENT_TITLE_OWN: '¿Deseas eliminar tu comentario?',
    DELETE_COMMENT_TITLE_OTHER:
      '¿Deseas eliminar el comentario de {{userName}}?',
    DELETE_COMMENT_SUBTITLE: 'Al confirmar, no podrás revertir esta acción.',
    DELETE_COMMENT_CTA_CANCEL: 'Cancelar',
    DELETE_COMMENT_CTA_CONFIRM: 'Sí, eliminar',

    POSTS_FEED_RECENT_POSTS: 'Ver publicaciones recientes',
    POSTS_FEED_NEW_POSTS: 'Hay nuevas publicaciones',

    REACTION_TABLE_USER_HEADER: 'Nombre',

    CONFIRM_DIALOG_TITLE: '¿Deseas salir y descartar la publicación?',
    CONFIRM_DIALOG_TITLE_EDIT: '¿Deseas salir sin guardar los cambios?',
    CONFIRM_DIALOG_DESCRIPTION: 'Se perderá la información que ingresaste.',
    CONFIRM_DIALOG_DESCRIPTION_EDIT:
      'Se perderán las modificaciones que realizaste.',
    CONFIRM_DIALOG_CANCEL_TEXT: 'Cancelar',
    CONFIRM_DIALOG_CONFIRM_TEXT: 'Sí, salir',

    CREATE_NEW_POST_INPUT_BUTTON_LABEL: '¿Qué deseas comunicar hoy?',
    CREATE_NEW_POST_INPUT_TITLE: 'Crear publicación',
    CREATE_NEW_POST_INPUT_TITLE_EDIT: 'Editar publicación',
    CREATE_NEW_POST_INPUT_DESCRIPTION:
      'Escribe un mensaje para tu comunidad. Puedes agregar imágenes, videos y enlaces.',
    CREATE_NEW_POST_INPUT_CONFIRM_BUTTON_LABEL: 'Publicar',
    CREATE_NEW_POST_INPUT_SCHEDULE_BUTTON_LABEL: 'Programar',
    CREATE_NEW_POST_INPUT_SAVE_BUTTON_LABEL: 'Guardar',
    CREATE_NEW_POST_INPUT_PUBLISH_NOW_BUTTON_LABEL: 'Publicar ahora',
    CREATE_NEW_POST_INPUT_PLACEHOLDER:
      'Escribe una publicación y/o utiliza @ para mencionar a alguien',
    CREATE_NEW_POST_INPUT_REACH_LABEL: 'Alcance: {{count}} persona',
    CREATE_NEW_POST_INPUT_REACH_LABEL_plural: 'Alcance: {{count}} personas',

    CREATE_NEW_POST_INPUT_SUCCESS_MESSAGE: 'Mensaje publicado con éxito.',
    CREATE_NEW_POST_INPUT_SCHEDULED_SUCCESS_MESSAGE:
      'Publicación programada con éxito.',
    UPDATE_POST_INPUT_SUCCESS_MESSAGE: 'Cambios guardados con éxito.',
    DELETE_POST_INPUT_SUCCESS_MESSAGE: 'La publicación se eliminó con éxito.',

    POST_DELETE_TITLE: '¿Deseas eliminar la publicación?',
    POST_DELETE_BUTTON: 'Eliminar',
    POST_EDIT_BUTTON: 'Editar',
    POST_SHARE_LINK_BUTTON: 'Compartir enlace',
    POST_SHARE_LINK_SUCCESS_TITLE: 'El enlace se copió en el portapapeles',
    POST_SHARE_LINK_ERROR_TITLE: 'Error al generar el link',
    POST_SHARE_LINK_ERROR_DESCRIPTION:
      'No fue posible generar el enlace. Por favor, inténtalo nuevamente.',
    POST_DELETE_DESCRIPTION:
      'Esta acción es irreversible. Si la publicación tiene comentarios, estos también se eliminarán de forma permanente.',
    POST_DELETE_CONFIRM_BUTTON: 'Sí, eliminar',
    POST_DELETE_SUCCESS_MESSAGE: 'La publicación se eliminó con éxito.',

    UPLOAD_FILE_INPUT_BUTTON_LABEL: 'Subir imagen',
    UPLOAD_FILE_INPUT_LABEL_DESCRIPTION:
      'Formato: JPG, PNG, GIF, MP4 o MOV.\nTamaño: 1280 x 720 px.\nMax: 5 MB imagen y 1 GB video.',
    UPLOAD_FILE_INPUT_FORMAT_LABEL: 'Pesos y formatos',

    // Channels view
    CHANNELS_VIEW_TRIGGER_BUTTON: 'Ver canales',
    CHANNELS_VIEW_TITLE: 'Canales',
    CHANNELS_VIEW_CHANNEL_SEARCH_PLACEHOLDER: 'Buscar canal',
    CHANNELS_VIEW_CHANNEL_CREATE_BUTTON: 'Crear canal',
    CHANNELS_VIEW_CHANNEL_DISCOVER_BUTTON: 'Descubrir canales',
    CHANNELS_VIEW_CHANNEL_MAIN_CHANNEL: 'Principal',
    CHANNELS_VIEW_CHANNEL_OTHER_CHANNELS: 'Más canales',
    CHANNELS_VIEW_CHANNEL_OTHER_CHANNELS_END_USER: 'Eres miembro de',
    CHANNELS_VIEW_ERROR_TITLE: 'Ocurrió un error',
    CHANNELS_VIEW_ERROR_DESCRIPTION:
      'Haz clic en el botón para reintentar cargar nuevamente.',
    CHANNELS_VIEW_EMPTY_TITLE: 'No se encontraron resultados para',
    CHANNELS_VIEW_EMPTY_DESCRIPTION:
      'Inténtalo de nuevo con un término diferente.',

    // Leave Channel
    LEAVE_CHANNEL_BUTTON: 'Abandonar canal',
    LEAVE_CHANNEL_TITLE: '¿Deseas abandonar el canal {{name}}?',
    LEAVE_CHANNEL_DESCRIPTION:
      'Tus mensajes seguirán visibles en el canal hasta que un administrador los elimine. Puedes volver a unirte si aún tienes los permisos necesarios para acceder al canal.',
    LEAVE_CHANNEL_CTA: 'Sí, abandonarlo',
    CHANNEL_LEAVE_SUCCESS: 'Abandonaste el canal {{name}} correctamente.',
    CHANNEL_LEAVE_SUCCESS_DESCRIPTION:
      'Puedes volver a unirte si aún tienes los permisos necesarios para acceder al canal.',

    // Edit Channel
    EDIT_CHANNEL_BUTTON: 'Editar configuración',

    // Moderators selector
    STEP_3_ASSIGNED_USERS_TITLE: 'Usuarios asignados',
    STEP_3_ASSIGNED_USERS_PLACEHOLDER: 'Seleccionar usuarios',
    STEP_3_ASSIGNED_USERS_SEARCH_PLACEHOLDER: 'Buscar',
    STEP_3_ASSIGNED_USERS_EMPTY: 'No hay usuarios disponibles.',
    STEP_3_ASSIGNED_USERS_REMOVE_LABEL: 'Quitar usuario',
    STEP_3_MODERATORS_LIMIT_REACHED: 'Llegaste al límite de 100 moderadores.',

    // Delete Channel
    DELETE_CHANNEL_BUTTON: 'Eliminar',
    DELETE_CHANNEL_TITLE: '¿Deseas eliminar el canal {{name}}?',
    DELETE_CHANNEL_DESCRIPTION:
      'Esta acción es irreversible y perderás todas las publicaciones, sus comentarios y métricas. Escribe “ELIMINAR” para confirmar la acción.',
    DELETE_CHANNEL_CONFIRMATION: 'ELIMINAR',
    DELETE_CHANNEL_CTA: 'Sí, eliminar',
    CHANNEL_DELETE_SUCCESS: 'La eliminación se realizó correctamente.',
    CHANNEL_DELETE_SUCCESS_DESCRIPTION:
      'Recuerda que no podrás revertir esta acción.',
    CHANNEL_DELETE_ERROR: 'No fue posible completar la eliminación ',
    CHANNEL_DELETE_ERROR_DESCRIPTION:
      'Por favor, inténtalo de nuevo más tarde.',

    // Convert to main channel
    CONVERT_TO_MAIN_CHANNEL_BUTTON: 'Convertir en canal principal',
    CONVERT_TO_MAIN_CHANNEL_TITLE: '¿Deseas convertir este canal en principal?',
    CONVERT_TO_MAIN_CHANNEL_DESCRIPTION:
      'Antes de confirmar, ten en cuenta estas consideraciones sobre el canal principal:',
    CONVERT_TO_MAIN_CHANNEL_MESSAGE_1:
      'El canal principal es el que primero se muestra al ingresar a “Comunidad”.',
    CONVERT_TO_MAIN_CHANNEL_MESSAGE_2:
      'No podrás editar la configuración de “Permisos para unirse”, ya que el canal principal debe ser siempre público, incluir a toda la compañía automáticamente y no puede ser abandonado.',
    CONVERT_TO_MAIN_CHANNEL_MESSAGE_3:
      'Si este canal tiene usuarios que lo abandonaron, serán reincorporados automáticamente al establecerlo como principal.',
    CONVERT_TO_MAIN_CHANNEL_MESSAGE_4:
      'No podrás eliminar el canal principal hasta asignar otro en su lugar.',
    CONVERT_TO_MAIN_CHANNEL_CONFIRMATION:
      'Confirmo que entiendo las implicancias y deseo continuar con el cambio.',
    CONVERT_TO_MAIN_CHANNEL_CTA: 'Sí, convertir',
    CHANNEL_CONVERT_TO_MAIN_SUCCESS:
      'El canal fue establecido como canal principal correctamente.',
    CHANNEL_CONVERT_TO_MAIN_SUCCESS_DESCRIPTION:
      'Todos los usuarios activos y pendientes van a unirse automáticamente a este canal.',

    // Upload image or video dialog
    UPLOAD_IMAGE_OR_VIDEO_BUTTON_LABEL: 'Imagen o video',
    UPLOAD_IMAGE_BUTTON_ARIA_LABEL: 'Subir imagen',
    UPLOAD_VIDEO_BUTTON_ARIA_LABEL: 'Subir video',
    UPLOAD_IMAGE_OR_VIDEO_DIALOG_TITLE: 'Subir imagen o video',
    UPLOAD_IMAGE_OR_VIDEO_ALT_TEXT_LABEL:
      'Descripción alternativa para accesibilidad',
    UPLOAD_IMAGE_OR_VIDEO_ALT_TEXT_DESCRIPTION:
      'Los lectores de pantalla leen esto para las personas con discapacidad visual.',
    UPLOAD_IMAGE_OR_VIDEO_ALT_TEXT_PLACEHOLDER:
      'Descripción breve de la imagen',
    UPLOAD_VIDEO_ALT_TEXT_PLACEHOLDER: 'Descripción breve del video',
    MULTI_IMAGE_HEADER_LABEL: 'Imágenes',
    MULTI_IMAGE_REORDER_HINT: 'Arrastra las miniaturas para reordenar.',
    MULTI_IMAGE_ADD_MORE_ARIA_LABEL: 'Agregar más imágenes',
    MULTI_IMAGE_DELETE_ARIA_LABEL: 'Eliminar imagen',
    DELETE_BUTTON_TOOLTIP: 'Eliminar',
    MULTI_IMAGE_MAX_REACHED_ERROR:
      'Has alcanzado el máximo de {{max}} imágenes.',
    MULTI_IMAGE_LIMIT_REACHED_TOOLTIP:
      'Llegaste al límite de {{max}} imágenes por publicación.',
    MULTI_IMAGE_DELETE_CONFIRM_TITLE: '¿Deseas eliminar la imagen?',
    MULTI_IMAGE_DELETE_CONFIRM_DESCRIPTION:
      'Esta acción no se puede deshacer. La imagen se quitará de la publicación.',
    MULTI_IMAGE_DELETE_CONFIRM_BUTTON: 'Sí, eliminar',
    MULTI_IMAGE_DELETE_SUCCESS: 'Imagen eliminada correctamente.',
    IMAGE_SIZE_EXCEEDED_ERROR_TITLE:
      '{{count}} archivo(s) superan el límite de peso permitido.',
    IMAGE_SIZE_EXCEEDED_ERROR_DESCRIPTION:
      'El peso máximo por imagen es de 5 MB.',
    MULTI_IMAGE_UPLOADING_LABEL: 'Subiendo archivo',
    MULTI_IMAGE_CANCEL_UPLOAD_ARIA_LABEL: 'Cancelar carga',
    UPLOAD_IMAGE_OR_VIDEO_DIALOG_SUBMIT_BUTTON: 'Insertar',
    ALTERNATIVE_TEXT_ERROR_MESSAGE:
      'Solo debes ingresar letras, números, espacios, guiones, paréntesis, puntos y comas.',

    CREATE_NEW_POST_INPUT_NOTIFY_LABEL: 'Notificar',
    CREATE_NEW_POST_INPUT_NOTIFY_TOOLTIP:
      'Activa la opción si deseas notificar esta publicación a tu audiencia por correo.',
    SCHEDULE_FOR_LATER_LABEL: 'Programar para más tarde',
    SCHEDULE_FOR_LATER_DESCRIPTION:
      'Define una fecha y hora para que la publicación se publique automáticamente.',
    SCHEDULE_DATE_LABEL: 'Fecha',
    SCHEDULE_DATE_PLACEHOLDER: 'Selecciona una fecha',
    SCHEDULE_TIME_LABEL: 'Hora',
    SCHEDULE_TIME_PLACEHOLDER: 'Seleccionar hora',
    SCHEDULE_TIMEZONE_LABEL: 'Zona horaria',
    SCHEDULED_EMPTY_TITLE: 'Aún no hay publicaciones programadas',
    SCHEDULED_EMPTY_DESCRIPTION:
      'Aquí se mostrarán los mensajes que se publicarán a futuro en una fecha y hora específica.',
    SCHEDULED_CREATE_BUTTON: 'Crear publicación',
    SCHEDULED_TABLE_DESCRIPTION:
      'Los administradores y moderadores visualizan todas las publicaciones del canal.',
    SCHEDULED_SEARCH_PLACEHOLDER: 'Buscar',
    SCHEDULED_COLUMN_POST: 'Publicación programada',
    SCHEDULED_COLUMN_PRE_CREATION_DATE: 'Fecha de pre-creación',
    SCHEDULED_COLUMN_SCHEDULED_DATE: 'Fecha programada',
    SCHEDULED_COLUMN_ACTIONS: 'Acciones',
    SCHEDULED_PRE_CREATION_TOOLTIP:
      'Esta fecha no figurará en el mensaje cuando se publique, pero sí el autor original.',
    SCHEDULED_USER_DEACTIVATED_TOOLTIP:
      'Usuario eliminado o desactivado de la plataforma',
    SCHEDULED_ACTION_OPEN_ACTIONS: 'Abrir acciones de la publicación',
    SCHEDULED_ACTION_PREVIEW: 'Vista previa',
    SCHEDULED_ACTION_EDIT: 'Editar',
    SCHEDULED_ACTION_HISTORY: 'Ver historial de cambios',
    SCHEDULED_ACTION_PUBLISH_NOW: 'Publicar ahora',
    SCHEDULED_ACTION_DELETE: 'Eliminar',
    SCHEDULED_SEARCH_EMPTY_TITLE: 'No se encontraron resultados para',
    SCHEDULED_SEARCH_EMPTY_DESCRIPTION:
      'Inténtalo de nuevo con un término diferente.',
    SCHEDULED_SORT_NEWEST: 'Más recientes',
    SCHEDULED_SORT_OLDEST: 'Más antiguas',
    SCHEDULED_BY_AUTHOR: 'Por: {{name}}',
    SCHEDULED_AT_CONNECTOR: 'a la(s)',
    SCHEDULED_BULK_DELETE_TOOLTIP: 'Eliminar',
    SCHEDULED_PUBLISH_NOW_DIALOG_TITLE: '¿Deseas publicar el mensaje ahora?',
    SCHEDULED_PUBLISH_NOW_DIALOG_DESCRIPTION:
      'El mensaje dejará de estar programado y se mostrará inmediatamente en el muro del canal.',
    SCHEDULED_PUBLISH_NOW_DIALOG_CONFIRM: 'Sí, publicar',
    SCHEDULED_PUBLISH_NOW_SUCCESS: 'Mensaje publicado con éxito.',
    SCHEDULED_DELETE_DIALOG_TITLE: '¿Deseas eliminar la publicación?',
    SCHEDULED_DELETE_DIALOG_DESCRIPTION:
      'Esta acción es irreversible y perderás el contenido de la publicación.',
    SCHEDULED_DELETE_DIALOG_CONFIRM: 'Sí, eliminar',
    SCHEDULED_DELETE_SUCCESS: 'La eliminación se realizó correctamente.',
    SCHEDULED_DELETE_SUCCESS_DESCRIPTION:
      'Recuerda que no podrás revertir esta acción.',
    SCHEDULED_DELETE_ERROR: 'No fue posible completar la eliminación',
    SCHEDULED_DELETE_ERROR_DESCRIPTION:
      'Por favor, inténtalo de nuevo más tarde.',
    SCHEDULED_BULK_DELETE_DIALOG_TITLE:
      '¿Deseas eliminar {{count}} publicación?',
    SCHEDULED_BULK_DELETE_DIALOG_TITLE_MULTIPLE:
      '¿Deseas eliminar {{count}} publicaciones?',
    SCHEDULED_BULK_DELETE_DIALOG_DESCRIPTION:
      'Esta acción es irreversible y perderás el contenido de los mensajes. Escribe "ELIMINAR" para confirmar la acción.',
    SCHEDULED_BULK_DELETE_DIALOG_CONFIRMATION: 'ELIMINAR',
    SCHEDULED_BULK_DELETE_DIALOG_CONFIRM: 'Sí, eliminar',
    SCHEDULED_BULK_DELETE_DIALOG_CONFIRM_INPUT_LABEL:
      'Escribe {{word}} para confirmar la eliminación',
    SCHEDULE_TIME_INVALID: 'Hora inválida, selecciona una hora a futuro.',
    SCHEDULED_PREVIEW_DIALOG_TITLE: 'Vista previa de la publicación',
    SCHEDULED_PREVIEW_CREATION_DATE: 'Creación: {{date}}',
    SCHEDULED_PREVIEW_SCHEDULED_DATE: 'Programación: {{date}}',
    SCHEDULED_PREVIEW_ONLY_PREVIEW_TEXT: 'Hace menos de un minuto',
    SCHEDULED_PREVIEW_SHOW_MORE: 'Ver más',
    SCHEDULED_PREVIEW_SHOW_LESS: 'Ver menos',
  },
};
